import { AvailableIcons } from '@asn/icon';

import { Component, ViewEncapsulation, output, input, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApContentService } from '@ap/content';
import { AbstractInputComponent, ApAutocompleteFilterService, ApAutocompleteModule, InputmodeType, InputType } from '@ap/input';
import { ApInputConstraintService } from '@ap/input/constraint';
import { ApSuggestionComponent } from '@ap/input/suggestion';
import { ApFormErrorsComponent } from '@ap/form/errors';
import '@asn/icon';

import content from './search-input.content.json';

@Component({
    selector: 'ap-search-input',
    templateUrl: '../../../src/lib/input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ReactiveFormsModule, FormsModule, ApSuggestionComponent, ApFormErrorsComponent, ApAutocompleteModule, NgTemplateOutlet],
    providers: [ApInputConstraintService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApSearchInputComponent extends AbstractInputComponent {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);
    protected readonly filterService = inject(ApAutocompleteFilterService);

    /**
     * Emits event if icon is clicked
     */
    // eslint-disable-next-line @angular-eslint/no-output-native
    public readonly search = output<string>();

    /**
     * Maxlength of input
     */
    public readonly maxlength = input<number>(null);

    /**
     * Inputmode (Standard HTML inputmode types)
     */
    protected readonly inputmode = input<InputmodeType>('search');

    /**
     * Action Icon
     */
    protected readonly icon = input<AvailableIcons>('magnifier');

    /**
     * Use native browser input
     */
    protected readonly type = input<InputType>('search');

    constructor() {
        super();
        this.setDefaultContent(content, 'search-input');
    }

    /**
     * Overwrite standard search event
     * Emit search action
     */
    protected override onSearch(event: Event): void {
        event.stopPropagation();
        this.search.emit(this.value);
    }

    /**
     * Overwrite standard icon click
     * Emit search action
     */
    protected override handleIconClick(event: Event): void {
        event.preventDefault();
        this.search.emit(this.value);
    }
}
